module.exports = __webpack_public_path__ + "static/media/cinecruise-1.773eee17.jpg";